<template>
  <div>
    <v-dialog
        persistent
        v-model="showDialog"
        max-width="480"
        overlay-opacity="0.9"
        :dark="compColor.isInDarkMode"
        :color="compColor.primeColor"
        style="overflow:hidden;z-index: 9999 !important;"
    >
      <div class="elevation-10 layout-column" style="border-radius: 6px;"
           v-bind:style="{background: compColor.contentFrame}">
        <!-- HEADER -->
        <div class="text-h6 font-weight-light pa-3 layout-row layout-align-center-center"
             :class="isDarkMode? 'blue-grey--text text--lighten-2' : ' grey--text text--darken-2'">
          {{ $t(title) }}
        </div>

        <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

        <!-- CONTENT (default slot) -->
        <div class="ma-1 px-3 py-5 layout-column elevation-3" style="border-radius: 5px;position: relative;" :style="{'background': compColor.lxExpansion.background}">
          <div class="layout-row">
            <div class="layout-column layout-align-center-center mr-3">
              <v-avatar tile :color="isDarkMode ? compColor.prime : 'grey lighten-3'">
                <v-icon :color="isDarkMode ? 'white' : compColor.primeColor">info</v-icon>
              </v-avatar>
            </div>
            <div class="flex layout-column layout-align-center-start" :class="isDarkMode? 'blue-grey--text text--lighten-2' : 'blue-grey--text text--darken-2'" v-html="$t(message)"></div>
          </div>
        </div>

        <!-- ACTIONS -->
        <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

        <div class="layout-row layout-align-end-center pa-1">

          <v-btn depressed :disabled="isLoading" :color="compColor.prime" :dark="isDarkMode" class="flex white--text text-none mr-1" @click="close()">
            {{ $t('FORM_MISMATCH_DIALOG.BTN_CONTINUE_UPDATE') }}
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'FormMismatchDialog',
    props: {
      showDialog: Boolean,
      isLoading: Boolean,
      title: String,
      message: String
    },
    methods: {
      close () {
        this.$emit('close-form-update-dialog')
      }
    }
  }
</script>

<style scoped>
.v-overlay { z-index: 20001 !important; }
.v-dialog__content { z-index: 20002 !important; }
</style>
